// extracted by mini-css-extract-plugin
export var addButton = "_fv-0";
export var border = "_fv-8";
export var check = "_fv-h";
export var danger = "_fv-6";
export var dropdownContainer = "_fv-1";
export var editModalBody = "_fv-j";
export var footerContainer = "_fv-i";
export var fullWidth = "_fv-a";
export var hide = "_fv-9";
export var icon = "_fv-3";
export var input = "_fv-7";
export var inputFlex = "_fv-b";
export var inputWrapper = "_fv-c";
export var manualFocus = "_fv-5";
export var optionButton = "_fv-4";
export var pillWrapper = "_fv-e";
export var pointer = "_fv-2";
export var showOverflow = "_fv-f";
export var tagsFlex = "_fv-d";
export var xButton = "_fv-g";